import React from 'react'

export default function CombinedTrainingRequirements() {
    return <div>Combined Training Requirements</div>
}
